export default "__VITE_ASSET__DF1Os4Nj__"